import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import AccountForm from "./accountComponents/AccountForm";

import {
  useGetAccountDetailQuery,
  useUpdateAccountMutation,
} from "store/services/accountApi";

import { useAppMeta } from "hooks";

const AccountEditScreen = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Accounts", path: "/app/crm/account/list" },
    { title: "Edit Account" },
  ];

  // RTK Query
  const {
    data: accountDetail,
    isLoading: loadingAccount,
    error,
  } = useGetAccountDetailQuery(id);

  const [updateAccount, { isLoading: updatingAccount }] =
    useUpdateAccountMutation();

  // methods
  const handleUpdateAccount = async (data) => {
    const _payload = data;

    delete _payload.disclaimers;

    try {
      await updateAccount(_payload).unwrap();
      toast.success("Account successfully updated!");
      navigate(`/app/crm/account/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update Account!"
      );
    }
  };

  useAppMeta("Edit Account");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingAccount || updatingAccount}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <AccountForm
          isBusy={loadingAccount || updatingAccount}
          accountDetail={accountDetail}
          onSubmit={handleUpdateAccount}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default AccountEditScreen;
